export const MODE = {
  confirmation: 'confirmation',
  warning: 'warning',
};
